module.exports = __webpack_public_path__ + "img/chofu_all_on.7f6c330c.svg";